export function deepClone(o) {
  return JSON.parse(JSON.stringify(o))
}